"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const test_ids_1 = __importDefault(require("@/accessibility/test-ids"));
const components_1 = require("@/components");
const base_form_1 = __importDefault(require("@/components/base-form"));
const buttons_1 = require("@/components/base-form/buttons");
const fields_1 = require("@/components/base-form/fields");
const form_error_1 = __importDefault(require("@/components/base-form/form-error"));
const constants_1 = __importStar(require("@/constants"));
const services_1 = require("@/helpers/services");
const api_payloads_1 = require("@/redux/api-payloads");
const field_names_1 = require("../field-names");
const schemas_1 = require("../schemas");
const styles_scss_1 = __importDefault(require("./styles.scss"));
const initialValues = {
    [field_names_1.LoginFieldNames.email]: '',
    [field_names_1.LoginFieldNames.password]: '',
};
const initialErrors = {
    [field_names_1.LoginFieldNames.email]: constants_1.default.general.requiredField('Email'),
    [field_names_1.LoginFieldNames.password]: constants_1.default.general.requiredField('Password'),
};
const LoginForm = () => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement(base_form_1.default, { initialValues: initialValues, validationSchema: schemas_1.LoginSchema, onSubmitPayload: api_payloads_1.loginPayload, formKey: services_1.endpoints.login, initialErrors: initialErrors },
        react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: styles_scss_1.default.loginInputRow },
                react_1.default.createElement(fields_1.EmailField, { name: field_names_1.LoginFieldNames.email, label: constants_1.default.login.email, placeholder: constants_1.default.login.email, testId: test_ids_1.default.Login.Email })),
            react_1.default.createElement("div", { className: styles_scss_1.default.loginInputRow },
                react_1.default.createElement(fields_1.PasswordField, { name: field_names_1.LoginFieldNames.password, label: constants_1.default.login.password, placeholder: constants_1.default.login.password, testId: test_ids_1.default.Login.Password }))),
        react_1.default.createElement(form_error_1.default, { formKey: services_1.endpoints.login }),
        react_1.default.createElement("div", { className: styles_scss_1.default.buttons },
            react_1.default.createElement(buttons_1.SubmitButton, { disableOnErrors: true, className: styles_scss_1.default.loginButton, title: constants_1.default.login.signIn, testId: test_ids_1.default.Login.Submit }))),
    react_1.default.createElement("div", { className: styles_scss_1.default.buttons },
        react_1.default.createElement(components_1.Link, { to: constants_1.Routes.ResetPassword, className: styles_scss_1.default.forgetButton },
            react_1.default.createElement("span", null, constants_1.default.login.forgotPassword)))));
exports.default = LoginForm;
